import { CrudService } from '../base/CrudService';
export class ProcurementRoleAssignmentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProcurementRoleAssignmentService.DEFAULT_SERVICE_PATH,
            basePath: ProcurementRoleAssignmentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAllViewModels() {
        const response = await this.http.get(this.buildUrl('view-models'));
        return response.data ?? [];
    }
    async deleteByCompositeKey(userId, roleTypeId) {
        const response = await this.http.delete(this.buildUrl(`${userId}/${roleTypeId}`));
        return response.success ?? false;
    }
}
ProcurementRoleAssignmentService.DEFAULT_SERVICE_PATH = 'procurements';
ProcurementRoleAssignmentService.BASE_PATH = 'api/procurementroleassignment';
//# sourceMappingURL=ProcurementRoleAssignmentService.js.map